<template>
  <div class="form-wrapper-parrent">
    <div class="form-wrapper" id="form-wrapper">
      <div
        v-if="
          activeQuestion &&
            (activeQuestion.type === 'MultipleChoiceQuizType' ||
              activeQuestion.type === 'TrueFalseType')
        "
        class="f-timer"
      >
        <icon name="stopwatch" />
        <span>{{ formatTime(time) }}</span>
      </div>
      <div
        class="vff"
        :class="{
          'vff-not-standalone': !standalone,
          'vff-is-mobile': isMobile,
          'vff-is-ios': isIos
        }"
      >
        <div class="f-container">
          <flow-form-question
            ref="questions"
            v-for="(q, index) in questionList"
            v-bind:question="q"
            v-bind:language="language"
            v-bind:key="'q' + index"
            v-bind:active="q.id === activeQuestionId"
            v-bind:submitted="submitted"
            v-model="q.answer"
            v-on:answer="onQuestionAnswered"
            v-on:submit="submit()"
            v-bind:reverse="reverse"
            v-bind:disable-answer="disableAnswer"
            v-bind:isQuiz="template === 'quiz'"
          />
          <!-- Complete/Submit screen slots -->
          <div
            v-if="isOnLastStep"
            class="vff-animate f-fade-in-up field-submittype complete-wrapper"
          >
            <slot name="complete">
              <!-- Default content for the "complete" slot -->
              <template v-if="!isUploadingFile">
                <div class="f-section-wrap text-center">
                  <p>
                    <span class="fh4">{{ endPage.title }}</span>
                  </p>
                  <span v-html="endPage.description" />
                </div>
                <div class="share-wrapper text-center">
                  <input type="text" :value="url" ref="mylink" class="d-none" />
                  <p class="share" v-if="showShareLinks">
                    {{ $t("message.flow.share") }}
                  </p>
                  <div class="share-links">
                    <div
                      class="share-btn"
                      @click.prevent="toggleModal()"
                      v-if="endPage.shareLinks.qr"
                    >
                      <icon name="qr" />
                    </div>
                    <div
                      class="share-btn"
                      @click.prevent="goToFblink()"
                      v-if="endPage.shareLinks.fb"
                    >
                      <icon name="fb" />
                    </div>
                    <div
                      class="share-btn"
                      @click.prevent="goToWaLink()"
                      v-if="endPage.shareLinks.wa"
                    >
                      <icon name="wa" />
                    </div>
                    <div
                      class="share-btn"
                      @click.prevent="copyToClipboard()"
                      v-if="endPage.shareLinks.es"
                    >
                      <icon name="es" />
                    </div>
                  </div>
                  <a class="return" href="http://www.survein.com">{{
                    $t("message.flow.returnToSurvein")
                  }}</a>
                </div>
              </template>
              <div v-else>
                <div class="upload-failed" v-if="isUploadingError">
                  <icon name="upload-failed" />
                  <h2 class="m-8">{{ $t("message.app.uploadErrorTitle") }}</h2>
                  <span>{{ $t("message.app.uploadErrorDesc") }}</span
                  ><br />
                  <a class="button-tryagain" @click="emitSubmit()">
                    {{ $t("message.app.retryUpload") }}
                  </a>
                </div>
                <p v-else>{{ $t("message.app.uploadingFiles") }}</p>
              </div>
            </slot>
          </div>
        </div>

        <div class="vff-footer" v-if="!isOnLastStep">
          <div
            v-if="activeQuestion && activeQuestion.required"
            class="required-question"
          >
            * required field
          </div>
          <div class="footer-inner-wrap">
            <div
              v-if="progressbar"
              class="f-progress"
              v-bind:class="{
                'not-started': percentCompleted === 0,
                completed: percentCompleted === 100
              }"
            >
              <div class="f-progress-bar">
                <div
                  class="f-progress-bar-inner"
                  v-bind:style="'width: ' + percentCompleted + '%;'"
                ></div>
              </div>
              <span>{{ numCompletedQuestions }}/{{ numActiveQuestions }}</span>
            </div>
            <div v-if="navigation" class="f-nav">
              <a
                class="f-prev"
                href="#"
                v-bind:class="{
                  'f-disabled':
                    activeQuestionIndex === 0 ||
                    submitted ||
                    template === 'quiz'
                }"
                v-on:click.prevent="goToPreviousQuestion()"
                role="button"
                v-bind:aria-label="language.ariaPrev"
              >
                {{ $t("message.flow.previousQuestion") }}
                <span class="f-nav-text" aria-hidden="true">{{
                  language.prev
                }}</span>
              </a>
              <a
                v-if="!isNextQuestionAvailable"
                class="f-next"
                href="#"
                v-bind:class="{
                  'f-disabled': this.submitted,
                  'f-disabled': isRequiredError
                }"
                v-on:click.prevent="submit()"
                role="button"
                v-bind:aria-label="language.ariaNext"
              >
                {{ $t("message.flow.submit") }}
                <span class="f-nav-text" aria-hidden="true">{{
                  language.next
                }}</span>
              </a>
              <a
                v-else
                class="f-next"
                href="#"
                v-bind:class="{
                  'f-disabled': !isNextQuestionAvailable,
                  'f-disabled': isRequiredError,
                  'd-none': isOnLastStep
                }"
                v-on:click.prevent="goToNextQuestion()"
                role="button"
                v-bind:aria-label="language.ariaNext"
              >
                {{ isOnLastStep ? "" : $t("message.flow.nextQuestion") }}
                <span class="f-nav-text" aria-hidden="true">{{
                  language.next
                }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Toast -->
      <transition name="slide-in">
        <div v-if="showToast" class="toast">
          <span>{{ $t("message.flow.linkCopied") }}</span>
          <div class="toast-close" @click.prevent="toggleToast()">x</div>
        </div>
      </transition>

      <transition name="slide-in">
        <!-- Modal -->
        <div id="myModal" class="modal" v-if="showQrModal">
          <!-- Modal content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-header-content">
                <span>{{ $t("message.flow.qrCode") }}</span>
                <div class="modal-close" @click.prevent="toggleModal()">
                  &times;
                </div>
              </div>
            </div>
            <div class="modal-body">
              <qr-code :text="url"></qr-code>
              <p class="mb-0">
                {{ $t("message.flow.qrCodeDesc") }}
              </p>
            </div>
            <div class="modal-footer">
              <div class="button button-cancel" @click.prevent="toggleModal()">
                {{ $t("message.flow.cancel") }}
              </div>
              <div class="button button-download" @click.prevent="downloadQr()">
                {{ $t("message.flow.download") }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import FlowFormQuestion from "./Question.vue";
import LanguageModel from "../models/LanguageModel";
import { IsMobile } from "../mixins/IsMobile";
import VueQRCodeComponent from "vue-qrcode-component";
import download from "downloadjs";
import icon from "../assets/svg/Icon";
import { isEqual, isBefore, isAfter } from "date-fns";
import { QuestionType } from "../../src/models/QuestionModel";

export default {
  name: "FlowForm",
  components: {
    FlowFormQuestion,
    "qr-code": VueQRCodeComponent,
    icon
  },

  props: {
    questions: Array,
    language: {
      type: LanguageModel,
      default: () => new LanguageModel()
    },
    progressbar: {
      type: Boolean,
      default: true
    },
    standalone: {
      type: Boolean,
      default: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    timer: {
      type: Boolean,
      default: false
    },
    timerStartStep: [String, Number],
    timerStopStep: [String, Number],
    endPage: {
      type: Object,
      default: () => ({
        title: "Thank you for filling our form!",
        description: "asd"
      })
    },
    isUploadingFile: {
      type: Boolean,
      default: false
    },
    isUploadingError: {
      type: Boolean,
      default: false
    },
    template: {
      type: String
    }
  },

  mixins: [IsMobile],

  data() {
    return {
      completed: false,
      submitted: false,
      activeQuestionIndex: 0,
      questionList: [],
      questionListActivePath: [],
      reverse: false,
      timerOn: false,
      timerInterval: null,
      time: 0,
      url: "",
      showToast: false,
      showQrModal: false,
      logicJumpRef: null,
      disableAnswer: false,
      totalScore: 0,
      totalCorrectAnswer: 0,
      totalWrongAnswer: 0
    };
  },

  mounted() {
    document.addEventListener("keydown", this.onKeyDownListener);
    document.addEventListener("keyup", this.onKeyUpListener, true);
    window.addEventListener("beforeunload", this.onBeforeUnload);

    this.setQuestions();
    this.url = window.location.href;

    let child = document.getElementById("form-wrapper");
    child.style.paddingRight = child.offsetWidth - child.clientWidth + "px";
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDownListener);
    document.removeEventListener("keyup", this.onKeyUpListener, true);
    window.removeEventListener("beforeunload", this.onBeforeUnload);

    this.stopTimer();
  },

  computed: {
    allQuestionsAnswered() {
      return this.numCompletedQuestions === this.questions.length;
    },

    showShareLinks() {
      return (
        this.endPage.shareLinks.es ||
        this.endPage.shareLinks.fb ||
        this.endPage.shareLinks.qr ||
        this.endPage.shareLinks.wa
      );
    },

    numActiveQuestions() {
      return this.questionList.length;
    },

    activeQuestion() {
      return this.questionList[this.activeQuestionIndex];
    },

    activeQuestionId() {
      const question = this.questionList[this.activeQuestionIndex];

      if (this.isOnLastStep) {
        return "_submit";
      }

      if (question && question.id) {
        return question.id;
      }

      return null;
    },

    numCompletedQuestions() {
      return this.activeQuestionIndex + 1;
    },

    percentCompleted() {
      if (!this.numActiveQuestions) {
        return 0;
      }

      if (this.numCompletedQuestions > this.numActiveQuestions) {
        return this.numActiveQuestions * 100;
      }

      return Math.floor(
        (this.numCompletedQuestions / this.numActiveQuestions) * 100
      );
    },

    isOnLastStep() {
      return this.activeQuestionIndex === this.questionList.length;
    },

    isOnTimerStartStep() {
      if (this.activeQuestionId === this.timerStartStep) {
        return true;
      }

      if (
        !this.timerOn &&
        !this.timerStartStep &&
        this.activeQuestionIndex === 0
      ) {
        return true;
      }

      return false;
    },

    isOnTimerStopStep() {
      if (this.submitted) {
        return true;
      }

      if (this.activeQuestionId === this.timerStopStep) {
        return true;
      }

      return false;
    },

    setTimer() {
      if (this.activeQuestion.timeLimit) {
        this.time = this.activeQuestion.timeLimit;
      }
    },

    /**
     * Checks if we have another question and if we
     * can jump to it.
     */
    isNextQuestionAvailable() {
      if (this.submitted) {
        return false;
      }

      const q = this.activeQuestion;

      return (
        !!q &&
        q.id !==
          this.questionListActivePath[this.questionListActivePath.length - 1].id
      );
    },

    isRequiredError() {
      if (this.activeQuestion) {
        if (this.activeQuestion.type === QuestionType.FileUpload) {
          return this.activeQuestion.required && !this.activeQuestion.answered;
        }

        return (
          this.activeQuestion.required &&
          (!this.activeQuestion.answer || this.activeQuestion.answer === "")
        );
      }
      return false;
    }
  },

  methods: {
    /**
     * Returns currently active question component (if any).
     */
    activeQuestionComponent() {
      if (this.$refs.questions) {
        return this.$refs.questions[this.activeQuestionIndex];
      }

      return null;
    },

    setQuestions() {
      this.setQuestionListActivePath();
      this.setQuestionList();
    },

    copyToClipboard() {
      var Url = this.$refs.mylink;
      Url.select();
      document.execCommand("copy");
      this.toggleToast();
    },

    toggleToast() {
      if (!this.showToast) {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 5000);
      } else {
        this.showToast = false;
      }
    },

    toggleModal() {
      if (!this.showQrModal) {
        this.showQrModal = true;
      } else {
        this.showQrModal = false;
      }
    },

    goToFblink() {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
        "_blank"
      );
    },

    goToWaLink() {
      const LinkTextToShare =
        "https://api.whatsapp.com/send?text=" +
        encodeURIComponent(window.location.href);

      window.open(LinkTextToShare, "_blank");
    },

    downloadQr() {
      var allImages = document.getElementsByTagName("img");
      var images = [];
      for (var i = 0, len = allImages.length; i < len; ++i) {
        if (allImages[i].alt == "Scan me!") {
          images.push(allImages[i]);
        }
      }

      download(images[0].currentSrc, "qr-code.png", "image/png");
    },

    /**
     * This method goes through all questions and sets the ones
     * that are in the current path (taking note of logic jumps)
     */
    setQuestionListActivePath() {
      const questions = [];
      let index = 0,
        serialIndex = 0,
        nextId;

      do {
        let question = this.questions[index];

        question.setIndex(serialIndex);
        question.language = this.language;

        questions.push(question);

        if (!question.jump) {
          ++index;
        } else if (question.answered) {
          nextId = question.getJumpId();
          if (nextId) {
            if (nextId === "_submit") {
              index = this.questions.length;
            } else {
              for (let i = 0; i < this.questions.length; i++) {
                if (this.questions[i].id === nextId) {
                  index = i;
                  break;
                }
              }
            }
          } else {
            ++index;
          }
        } else {
          index = this.questions.length;
        }

        ++serialIndex;
      } while (index < this.questions.length);

      this.questionListActivePath = questions;
    },

    /**
     * Sets the question list array
     * (all questions up to, and including, the current one)
     */
    setQuestionList() {
      const questions = [];

      let index = 0;

      if (!!this.logicJumpRef) {
        index = this.questionListActivePath.findIndex(
          question => question.id === this.logicJumpRef
        );
      }

      for (index; index < this.questionListActivePath.length; index++) {
        const question = this.questionListActivePath[index];

        questions.push(question);

        if (question.logics && question.logics.length > 0) {
          if (this.completed) {
            // The "completed" status changed - user probably changed an
            // already entered answer.
            this.completed = false;
          }
          break;
        }
      }
      this.questionList = [...new Set([...this.questionList, ...questions])];
      this.questionList.sort((a, b) => a.index - b.index);
    },

    /**
     * If we have any answered questions, notify user before leaving
     * the page.
     */
    onBeforeUnload(event) {
      if (this.activeQuestionIndex > 0 && !this.submitted) {
        event.preventDefault();
        event.returnValue = "";
      }
    },

    /**
     * Global key listeners, listen for Enter or Tab key events.
     */
    onKeyDownListener(e) {
      if (e.key !== "Tab" || this.submitted) {
        return;
      }

      if (e.shiftKey) {
        e.stopPropagation();
        e.preventDefault();

        if (this.navigation) {
          this.goToPreviousQuestion();
        }
      } else {
        const q = this.activeQuestionComponent();

        if (q.shouldFocus()) {
          e.preventDefault();

          q.focusField();
        } else {
          e.stopPropagation();

          this.emitTab();
          this.reverse = false;
        }
      }
    },

    onKeyUpListener(e) {
      if (
        e.shiftKey ||
        ["Tab", "Enter"].indexOf(e.key) === -1 ||
        this.submitted
      ) {
        return;
      }

      const q = this.activeQuestionComponent();

      if (e.key === "Tab" && q.shouldFocus()) {
        q.focusField();
      } else {
        if (e.key === "Enter") {
          this.emitEnter();
        }

        e.stopPropagation();
        this.reverse = false;
      }
    },

    handleLogics(question) {
      for (const logic of question.logics) {
        let answerDate =
          question.type === "DropdownDateType"
            ? new Date(
                question.answer.split("-")[2],
                (Number(question.answer.split("-")[0]) - 1).toString(),
                question.answer.split("-")[1]
              )
            : "";

        let questionDate =
          question.type === "DropdownDateType"
            ? new Date(
                logic.value.split("-")[0],
                (Number(logic.value.split("-")[1]) - 1).toString(),
                logic.value.split("-")[2]
              )
            : "";

        switch (logic.op) {
          case "contain":
            if (question.answer) {
              if (question.answer.includes(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "does_not_contain":
            if (question.answer) {
              if (!question.answer.includes(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "on":
            if (question.answer) {
              if (isEqual(answerDate, questionDate)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "not_on":
            if (question.answer) {
              if (!isEqual(answerDate, questionDate)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "before":
            if (question.answer) {
              if (isBefore(answerDate, questionDate)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "after":
            if (question.answer) {
              if (isAfter(answerDate, questionDate)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "before_or_on":
            if (question.answer) {
              if (
                isBefore(answerDate, questionDate) ||
                isEqual(answerDate, questionDate)
              ) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "after_or_on":
            if (question.answer) {
              if (
                isAfter(answerDate, questionDate) ||
                isEqual(answerDate, questionDate)
              ) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "equal_to":
            if (question.answer) {
              if (question.answer.length > 0) {
                if (question.answer[0] === logic.value) {
                  if (!logic.ref) {
                    this.logicJumpRef = question.logicJumps[0].to;
                  } else {
                    this.logicJumpRef = logic.ref;
                  }
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
              if (question.answer === logic.value) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                  return;
                }
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }

            break;

          case "not_equal_to":
            if (question.answer) {
              if (question.answer.length > 0) {
                if (question.answer[0] !== logic.value) {
                  if (!logic.ref) {
                    this.logicJumpRef = question.logicJumps[0].to;
                  } else {
                    this.logicJumpRef = logic.ref;
                  }
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }

              if (question.answer !== logic.value) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "greater_than":
            if (question.answer) {
              if (Number(question.answer) > Number(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "less_than":
            if (question.answer) {
              if (Number(question.answer) < Number(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "greater_or_equal_to":
            if (question.answer) {
              if (Number(question.answer) >= Number(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          case "less_or_equal_to":
            if (question.answer) {
              if (Number(question.answer) <= Number(logic.value)) {
                if (!logic.ref) {
                  this.logicJumpRef = question.logicJumps[0].to;
                } else {
                  this.logicJumpRef = logic.ref;
                }
              } else {
                this.logicJumpRef = question.logicJumps[0].to;
              }
            } else {
              this.logicJumpRef = question.logicJumps[0].to;
            }
            break;

          default:
            break;
        }
      }
    },

    emitEnter() {
      const q = this.activeQuestionComponent();

      this.$emit("add-score-point", this.calculateScore());
      this.$emit("add-correct-answer", this.calculateCorrectAnswer());
      this.$emit("add-wrong-answer", this.calculateWrongAnswer());

      if (q.question.logics.length > 0) {
        this.handleLogics(q.question);
      }

      if (q) {
        // Send enter event to the current question component
        q.onEnter();
      }
      if (this.completed && !this.isNextQuestionAvailable) {
        // We're finished - submit form
        this.submit();
      }
    },

    emitTab() {
      const q = this.activeQuestionComponent();

      if (q) {
        // Send tab event to the current question component
        q.onTab();
      } else {
        this.emitEnter();
      }
    },

    submit() {
      if (!this.isRequiredError) {
        this.$emit("add-score-point", this.calculateScore());
        this.$emit("add-correct-answer", this.calculateCorrectAnswer());
        this.$emit("add-wrong-answer", this.calculateWrongAnswer());
        this.emitSubmit();
        ++this.activeQuestionIndex;
        this.completed = true;
        this.submitted = true;
      }
    },

    emitComplete() {
      this.$emit("complete", this.completed, this.questionList);
    },

    emitSubmit() {
      this.$emit("submit", this.questionList);
    },

    /**
     * Triggered by the "answer" event in the Question component
     */
    onQuestionAnswered(question) {
      if (question.isValid()) {
        this.$emit("answer", question);

        this.$nextTick(() => {
          this.setQuestions();
          // Nested $nextTick so we're 100% sure that setQuestions
          // actually updated the question array
          this.$nextTick(() => {
            if (this.isNextQuestionAvailable) {
              if (
                !!this.logicJumpRef &&
                this.questionListActivePath.findIndex(
                  q => q.id === this.logicJumpRef
                ) <
                  this.questionListActivePath.findIndex(
                    q => q.id === this.activeQuestionId
                  )
              ) {
                this.activeQuestionIndex = this.questionList.findIndex(
                  q => q.id === this.logicJumpRef
                );
                this.logicJumpRef = null;
              } else {
                ++this.activeQuestionIndex;
                this.logicJumpRef = null;
              }
            }
            const q = this.activeQuestionComponent();

            if (q) {
              q.focusField();
              // this.activeQuestionIndex = q.question.index;
            }

            if (!this.isNextQuestionAvailable) {
              // No more questions left - set "completed" to true
              this.completed = true;
              // this.activeQuestionIndex = this.questionListActivePath.length;

              this.$refs.button && this.$refs.button.focus();
            }

            this.$emit("step", this.activeQuestionId, this.activeQuestion);
          });
        });
      } else if (this.completed) {
        this.completed = false;
      }
    },

    revertQuestionList() {
      if (this.questionList[this.activeQuestionIndex].logics.length) {
        const index = this.questionList.findIndex(
          question => question.id === this.activeQuestionId
        );
        this.questionList = this.questionList.slice(0, index + 1);
      }
    },

    /**
     * Jumps to previous question.
     */
    goToPreviousQuestion() {
      this.blurFocus();

      if (this.activeQuestionIndex > 0 && !this.submitted) {
        --this.activeQuestionIndex;

        this.reverse = true;

        this.revertQuestionList();
      }
    },

    /**
     * Jumps to next question.
     */
    goToNextQuestion() {
      this.blurFocus();
      if (this.isNextQuestionAvailable && !this.isRequiredError) {
        this.emitEnter();
      }

      this.reverse = false;
    },

    /**
     * Removes focus from the currently focused DOM element.
     */
    blurFocus() {
      document.activeElement &&
        document.activeElement.blur &&
        document.activeElement.blur();
    },

    checkTimer() {
      this.disableAnswer = false;
      this.calculateMaxScore();
      if (
        this.activeQuestion &&
        (this.activeQuestion.type === QuestionType.MultipleChoiceQuiz ||
          this.activeQuestion.type === QuestionType.TrueFalse)
      ) {
        this.time = this.activeQuestion.timeLimit;
        this.timerOn = true;
        this.startTimer();
      }
    },

    startTimer() {
      if (this.time === 0 || !this.timerOn) {
        this.disableAnswer = true;
        return;
      }

      if (this.time > 0) {
        setTimeout(() => {
          this.time -= 1;
          this.startTimer();
        }, 1000);
      }
    },

    stopTimer() {
      this.timerOn = false;
      this.time = 0;
    },

    formatTime(seconds) {
      if (seconds < 0) {
        seconds = 0;
      }

      let startIndex = 14,
        length = 5;

      if (seconds >= 60 * 60) {
        startIndex = 11;
        length = 8;
      }

      return new Date(1000 * seconds).toISOString().substr(startIndex, length);
    },

    calculateScore() {
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.StartPage
      ) {
        return 0;
      }
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.MultipleChoiceQuiz
      ) {
        if (this.activeQuestion.answerOptions === "single") {
          if (
            this.activeQuestion.answer === this.activeQuestion.correctAnswer[0]
          ) {
            this.activeQuestion.answerScore = this.activeQuestion.score;
            return this.activeQuestion.score;
          } else {
            return 0;
          }
        }
        if (
          this.activeQuestion &&
          this.activeQuestion.answerOptions === "multiple"
        ) {
          let total = 0;
          for (let singleAnswer of this.activeQuestion.answer) {
            if (this.activeQuestion.correctAnswer.includes(singleAnswer)) {
              this.activeQuestion.answerScore += this.activeQuestion.score;
              total += this.activeQuestion.score;
            }
          }
          return total;
        }
      }
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.TrueFalse
      ) {
        if (
          this.activeQuestion.answer === this.activeQuestion.correctAnswer[0]
        ) {
          this.activeQuestion.answerScore = this.activeQuestion.score;
          return this.activeQuestion.score;
        } else {
          return 0;
        }
      }
    },
    calculateCorrectAnswer() {
      let correctAnswer = 0;

      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.MultipleChoiceQuiz
      ) {
        if (this.activeQuestion.answerOptions === "single") {
          this.activeQuestion.answer === this.activeQuestion.correctAnswer[0]
            ? (correctAnswer += 1)
            : 0;
        }
        if (this.activeQuestion.answerOptions === "multiple") {
          for (let singleAnswer of this.activeQuestion.answer) {
            if (this.activeQuestion.correctAnswer.includes(singleAnswer)) {
              correctAnswer += 1;
            }
          }
        }
      }
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.TrueFalse
      ) {
        this.activeQuestion.answer === this.activeQuestion.correctAnswer
          ? (correctAnswer += 1)
          : 0;
      }
      return correctAnswer;
    },
    calculateWrongAnswer() {
      let wrongAnswer = 0;

      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.MultipleChoiceQuiz
      ) {
        if (this.activeQuestion.answerOptions === "single") {
          this.activeQuestion.answer === this.activeQuestion.correctAnswer[0]
            ? 0
            : (wrongAnswer += 1);
        }
        if (this.activeQuestion.answerOptions === "multiple") {
          for (let singleAnswer of this.activeQuestion.answer) {
            if (!this.activeQuestion.correctAnswer.includes(singleAnswer)) {
              wrongAnswer += 1;
            }
          }
        }
      }
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.TrueFalse
      ) {
        this.activeQuestion.answer === this.activeQuestion.correctAnswer
          ? 0
          : (wrongAnswer += 1);
      }
      return wrongAnswer;
    },
    calculateMaxScore() {
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.MultipleChoiceQuiz
      ) {
        if (this.activeQuestion.answerOptions === "single") {
          this.activeQuestion.maxScore = this.activeQuestion.score;
        }
        if (this.activeQuestion.answerOptions === "multiple") {
          this.activeQuestion.maxScore =
            this.activeQuestion.score *
            this.activeQuestion.correctAnswer.length;
        }
      }
      if (
        this.activeQuestion &&
        this.activeQuestion.type === QuestionType.TrueFalse
      ) {
        this.activeQuestion.maxScore = this.activeQuestion.score;
      }
    }
  },

  watch: {
    completed() {
      this.emitComplete();
    },

    submitted() {
      this.stopTimer();
    },

    activeQuestionIndex: {
      immediate: true,
      handler() {
        this.stopTimer();
        setTimeout(() => {
          this.checkTimer();
        }, 1000);
      }
    }
  }
};
</script>

<style lang="css">
@import "../assets/css/common.css";

.complete-wrapper {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-wrapper {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
}

.share-links {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.share-btn {
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
}

.share-btn:first-child {
  margin-left: 0;
}

.return {
  margin-top: 22px;
  text-decoration: none;
  display: inline-block;
}

.d-none {
  opacity: 0 !important;
}

.toast {
  width: 176px;
  height: 44px;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  box-sizing: border-box;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  top: 30px;
  font-family: "Proxima Nova", sans-serif;
}

.toast-close {
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.slide-in-enter,
.slide-in-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.35s ease;
}

.slide-in-enter-to {
  transform: translateY(0px);
  opacity: 1;
}

/* The Modal (background) */
.modal {
  /* display: none; Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  width: 300px;
  margin: auto;
  position: relative;
  padding: 0;
  background: #ffffff;
  border: 1px solid #dfeaf0;
  box-sizing: border-box;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-family: "Proxima Nova", sans-serif;
  /* -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s; */
}

.modal-header {
  height: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dfeaf0;
  font-size: 18px;
}

.modal-header-content {
  width: 86%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-weight: 700;
}

.modal-close {
  color: #606977;
  font-size: 20px;
  position: absolute;
  right: 20px;
  cursor: pointer;
}

.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 16px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #dfeaf0;
}

.button {
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.button-cancel {
  color: #dc3545;
  border: 1px solid #dc3545;
}

.button-download {
  color: var(--vff-button-text-color);
  background-color: var(--vff-button-color);
  margin-left: 8px;
}

.mb-0 {
  margin-bottom: 0px;
}

.button-tryagain {
  color: var(--vff-button-text-color) !important;
  background-color: var(--vff-button-color) !important;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  margin-top: 16px;
  display: inline-block;
}

.upload-failed {
  text-align: center;
}
</style>
